/**
 * STEMO: Localize Pareto QB widget ATC button using theme locale strings.
 * Pareto sometimes falls back to English when market/locale detection mismatches.
 */
(function () {
  const EN_LABELS = new Set(["Add to cart", "Add to Cart", "ADD TO CART"]);

  function getLocalizedLabel() {
    return window.themeVariables?.strings?.addToCartButton || "Lägg i varukorgen";
  }

  function shouldTranslate(text) {
    return EN_LABELS.has(text.trim());
  }

  function translateNode(node) {
    const label = getLocalizedLabel();
    node.querySelectorAll("button, a, [role='button']").forEach((element) => {
      const text = element.textContent.trim();
      if (shouldTranslate(text)) {
        element.textContent = label;
      }
    });
  }

  function scanParetoWidgets() {
    document.querySelectorAll(".omg-groupsTable, [id*='p_quantity_breaks']").forEach(translateNode);
  }

  function init() {
    scanParetoWidgets();

    const observer = new MutationObserver(scanParetoWidgets);
    document.querySelectorAll(".omg-groupsTable, [id*='p_quantity_breaks']").forEach((root) => {
      observer.observe(root, { childList: true, subtree: true, characterData: true });
    });

    document.addEventListener("shopify:section:load", scanParetoWidgets);
    window.addEventListener("load", scanParetoWidgets);
    setTimeout(scanParetoWidgets, 500);
    setTimeout(scanParetoWidgets, 1500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
